<div class="backdrop" fxLayout="column" fxLayoutAlign="center center">
    <div fxFlex fxLayout="column" fxLayoutGap="1vh" class="container" fxGrow="0">
        <span fxFlex>{{'You have reached the end of this scenario' | translate}}</span>
        <span fxFlex>{{'Now you will receive feedback on your choices.' | translate}}</span>
        <button fxFlex fxGrow="0" (click)="gotoFeedback()" mat-raised-button color="primary">{{'Get Feedback' |
            translate}}</button>
    </div>
</div>